import { BRAND_COLORS } from '../actions/types';

export default function brandColorReducer(state = [], action) {
	switch (action.type) {
		case BRAND_COLORS:
			return action.payload || { primaryColor: '#03B856' };
		default:
			return state;
	}
}
